document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wacc-gallery').forEach((gallery) => {
    const thumbs = gallery.querySelectorAll('.wacc-gallery__thumb');
    const slides = gallery.querySelectorAll('.wacc-gallery__slide');
    const main = gallery.querySelector('.wacc-gallery__main');
    let startX = 0;
    let currentIndex = 0;

    const activateSlide = (index) => {
      currentIndex = index;
      slides.forEach((slide) => slide.classList.remove('wacc-gallery__slide--active'));
      thumbs.forEach((thumb) => thumb.classList.remove('wacc-gallery__thumb--active'));
      slides[currentIndex]?.classList.add('wacc-gallery__slide--active');
      thumbs[currentIndex]?.classList.add('wacc-gallery__thumb--active');
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => activateSlide(index));
    });

    if (!main) return;

    main.addEventListener(
      'touchstart',
      (event) => {
        startX = event.touches[0].clientX;
      },
      { passive: true }
    );

    main.addEventListener(
      'touchend',
      (event) => {
        const diff = startX - event.changedTouches[0].clientX;
        if (Math.abs(diff) <= 50) return;
        if (diff > 0 && currentIndex < slides.length - 1) {
          activateSlide(currentIndex + 1);
        } else if (diff < 0 && currentIndex > 0) {
          activateSlide(currentIndex - 1);
        }
      },
      { passive: true }
    );
  });
});
